import React from "react"
import {HashRouter as Router, Route, Routes} from "react-router-dom"
import {observer} from "mobx-react";
import ListPatients from "./ListPatients";
import PerformExamination from "./PerformExamination";
import MedicalEventQuestionnaire from "../Appointment/MedicalEventQuestionnaire";

const InProgressEventRouter = observer(() => {


    return <div id="in-progress-event-view">
                <Router>
                    <Routes>
                        <Route path="/" exact element={<ListPatients/>}/>
                        <Route path="/appointment/:appointment_id" exact element={<PerformExamination/>}/>
                        <Route path="/appointment/:appointment_id/report" exact element={<MedicalEventQuestionnaire/>}/>
                    </Routes>
                </Router>
            </div>
})

export default InProgressEventRouter